/** =========================================================
 * Project parts controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-project-parts')
    .controller('ProjectPartsController', ProjectPartsController);

  ProjectPartsController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$resource', '$translate', '$location', 'ngDialog'];

  function ProjectPartsController($rootScope, $scope, $api, $state, $stateParams, $resource, $translate, $location, ngDialog) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;
      vm.indicatorsChanged = false;

      Raven.captureBreadcrumb({
        message: 'Page project parts',
        data: {
          filters: $stateParams.filters
        }
      });

      function array_move(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];

        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
      }

      var filters = function () {
        if (typeof $location.search().id !== 'undefined') {
          return [{
            'attr': 'where',
            'name': '',
            'value': [['id', '=', $location.search().id]]
          }];
        }

        return angular.copy($stateParams.filters);
      };

      var prepareData = function (item) {
        return new Promise(function (resolve, reject) {
          try {
            var actions = [];

            if (item.id) {
              actions.push(function () {
                return new Promise(function (resolveAction) {
                  item.project_part_acts = (item.project_part_acts || []).filter(function (act) {
                    return typeof act.type !== 'undefined';
                  });

                  item.project_part_acts.forEach(function (act) {
                    act.act_date = moment.isMoment(act.act_date) ? act.act_date.format($rootScope.appConfig.dateTimeFormat) : act.act_date;
                  });

                  resolveAction();
                });
              });

              item.project.project_documents.forEach(function (projectDocument) {
                if ($rootScope.helpers.hasPermissionTo('project_document add') && !projectDocument.id) {
                  actions.push(function () {
                    return $api.add({
                      model: 'project_document',
                      data: projectDocument
                    }).then(function (response) {
                      projectDocument.id = response.data.id;
                    });
                  });
                }
              });

              item.project.project_indicators.forEach(function (projectIndicator) {
                if ($rootScope.helpers.hasPermissionTo('project_indicator add') && !projectIndicator.id) {
                  actions.push(function () {
                    return $api.add({
                      model: 'project_indicator',
                      data: projectIndicator
                    }).then(function (response) {
                      projectIndicator.id = response.data.id;
                    });
                  });
                } else if ($rootScope.helpers.hasPermissionTo('project_indicator update') && vm.indicatorsChanged === true) {
                  actions.push(function () {
                    return $api.update({
                      model: 'project_indicator',
                      data: projectIndicator,
                      quiet: true
                    });
                  });
                }
              });

              item.project.project_approves.forEach(function (projectApprove) {
                if ($rootScope.helpers.hasPermissionTo('project_approve add') && !projectApprove.id) {
                  actions.push(function () {
                    return $api.add({
                      model: 'project_approve',
                      data: projectApprove
                    }).then(function (response) {
                      projectApprove.id = response.data.id;
                    });
                  });
                }
              });
            }

            $rootScope.helpers.promiseSequence(actions).then(function () {
              resolve(item);
            });
          } catch (error) {
            Raven.captureException(error);

            reject(error);
          }
        });
      };

      var getDocumentsAndIndicators = function (item) {
        return new Promise(function (resolve, reject) {
          try {
            var actions = [];

            actions.push(function () {
              return $api.resource({
                model: 'project_document',
                data: {
                  project_id: item.project_id,
                  order: { id: 'desc' }
                }
              }).then(function (response) {
                vm.tableConfig.lists.documents = response.data;
              });
            });

            actions.push(function () {
              return $api.resource({
                model: 'project_indicator',
                data: {
                  project_id: item.project_id,
                  selectOptions: ['id', 'name', 'value'],
                  order: { id: 'desc' }
                }
              }).then(function (response) {
                vm.tableConfig.lists.indicators = response.data;
              });
            });

            $rootScope.helpers.promiseSequence(actions).then(resolve);
          } catch (error) {
            Raven.captureException(error);

            reject(error);
          }
        });
      };

      var getRemarkTemplates = function () {
        return new Promise(function (resolve, reject) {
          try {
            var data = {
              selectOptions: ['id', 'name', 'user_id', 'project_part_act_remark_template_type_id']
            };

            $api.resource({ model: 'project_part_act_remark_template', data: data }).then(resolve);
          } catch (error) {
            Raven.captureException(error);

            reject(error);
          }
        });
      };

      var getIndicatorTemplates = function () {
        return new Promise(function (resolve, reject) {
          try {
            var data = {
              selectOptions: ['id', 'name', 'user_id']
            };

            $api.resource({ model: 'project_indicator_template', data: data }).then(resolve);
          } catch (error) {
            Raven.captureException(error);

            reject();
          }
        });
      };

      var copyProjectAttrs = function (item, project) {
        try {
          $scope.$applyAsync(function () {
            item.received = project.received;
            item.deadline = project.deadline;
            item.projector_id = project.projector_id;
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addAct = function (item) {
        try {
          item.project_part_acts.push({
            uid: item.project.uid + '.' + (item.project_part_acts.length + 1),
            project_part_id: item.id ? item.id : null,
            act_date: moment(),
            project_part_act_remarks: [],
            project_documents: [],
            project_indicators: [],
            project_approves: []
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addProjectItem = function (item, stackName, newProjectStackItem, index) {
        try {
          $scope.$applyAsync(function () {
            newProjectStackItem.project_id = item.project.id;
            newProjectStackItem.reference_project_part_id = item.id;

            item.project[stackName].splice(index, 0, newProjectStackItem);

            if (stackName === 'project_indicators') {
              vm.indicatorsChanged = true;

              item.project[stackName].map(function (stackItem, i) {
                stackItem.row_id = i;

                return stackItem;
              });
            }
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addRemark = function (act, value) {
        try {
          $scope.$applyAsync(function () {
            act.project_part_act_remarks.push({
              project_part_act_id: act.id,
              name: value || '---'
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addRemarkFromTemplates = function (act) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.data = [];
          dialogScope.allData = [];
          dialogScope.loading = true;
          dialogScope.selectAllValue = false;
          dialogScope.showOnlyMineValue = false;
          dialogScope.helpers = {
            hasPermissionTo: $rootScope.helpers.hasPermissionTo
          };

          dialogScope.search = function (value) {
            dialogScope.$applyAsync(function () {
              dialogScope.loading = true;

              if (value && value !== '') {
                var searchItems = value.split(' ');

                dialogScope.data = dialogScope.allData.filter(function (dataItem) {
                  return searchItems.some(function (searchItem) {
                    return dataItem.name.toLowerCase().includes(searchItem.toLowerCase());
                  });
                });
              } else {
                dialogScope.data = dialogScope.allData;
              }

              dialogScope.loading = false;
            });
          };

          dialogScope.toggleSelectAll = function (value) {
            dialogScope.$applyAsync(function () {
              dialogScope.loading = true;
              dialogScope.data = dialogScope.data.map(function (dataItem) {
                dataItem.selected = !value;

                return dataItem;
              });
              dialogScope.loading = false;
            });
          };

          dialogScope.toggleShowOnlyMineValue = function () {
            dialogScope.$applyAsync(function () {
              dialogScope.showOnlyMineValue = !dialogScope.showOnlyMineValue;
            });
          };

          dialogScope.showValue = function (value) {
            if (dialogScope.showOnlyMineValue === true) {
              return value.user_id === $rootScope.appConfig.user.id;
            }

            return true;
          };

          dialogScope.addTemplate = function () {
            var dialogScope2 = $scope.$new(true);

            dialogScope2.item = {};

            $api.resource({
              model: 'project_part_act_remark_template_type'
            }).then(function (response) {
              dialogScope2.resources = {
                project_part_act_remark_template_type: response.data
              };
            });

            ngDialog.openConfirm({
              template: 'app/views/dialogs/item-project-part-act-remark-template.html',
              className: 'ngdialog-theme-default',
              scope: dialogScope2
            }).then(function () {
              dialogScope.loading = true;

              $api.add({
                model: 'project_part_act_remark_template',
                data: dialogScope2.item
              }).then(function (response) {
                $api.getOne({
                  model: 'project_part_act_remark_template',
                  data: {
                    with: ['project_part_act_remark_template_type']
                  },
                  id: response.data.id
                }).then(function (response2) {
                  dialogScope.allData.unshift(response2.data);
                  dialogScope.data.unshift(response2.data);
                  dialogScope.loading = false;
                }, function () {
                  dialogScope.loading = false;
                });
              }, function () {
                dialogScope.loading = false;
              });
            });
          };

          getRemarkTemplates().then(function (response) {
            dialogScope.$applyAsync(function () {
              dialogScope.allData = response.data;
              dialogScope.data = response.data;
              dialogScope.loading = false;
            });
          });

          ngDialog.openConfirm({
            template: 'app/views/dialogs/project-part-act-remark-templates.html',
            className: 'ngdialog-theme-default ngdialog-wide',
            scope: dialogScope
          }).then(function () {
            dialogScope.$applyAsync(function () {
              dialogScope.data.forEach(function (remarkTemplate) {
                if (remarkTemplate.selected) {
                  act.project_part_act_remarks.push({
                    project_part_act_id: act.id,
                    name: remarkTemplate.name
                  });
                }
              });
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var addIndicatorFromTemplates = function (item, index) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.data = [];
          dialogScope.allData = [];
          dialogScope.loading = true;
          dialogScope.selectAllValue = false;
          dialogScope.showOnlyMineValue = false;
          dialogScope.sort = undefined;
          dialogScope.helpers = {
            hasPermissionTo: $rootScope.helpers.hasPermissionTo
          };

          dialogScope.search = function (value) {
            dialogScope.$applyAsync(function () {
              dialogScope.loading = true;

              if (value && value !== '') {
                var searchItems = value.split(' ');

                dialogScope.data = dialogScope.allData.filter(function (dataItem) {
                  return searchItems.some(function (searchItem) {
                    return dataItem.name.toLowerCase().includes(searchItem.toLowerCase());
                  });
                });
              } else {
                dialogScope.data = dialogScope.allData;
              }

              dialogScope.sort = undefined;
              dialogScope.loading = false;
            });
          };

          dialogScope.toggleSelectAll = function (value) {
            dialogScope.$applyAsync(function () {
              dialogScope.loading = true;
              dialogScope.data = dialogScope.data.map(function (dataItem) {
                dataItem.selected = !value;

                return dataItem;
              });
              dialogScope.loading = false;
            });
          };

          dialogScope.toggleShowOnlyMineValue = function () {
            dialogScope.$applyAsync(function () {
              dialogScope.showOnlyMineValue = !dialogScope.showOnlyMineValue;
            });
          };

          dialogScope.showValue = function (value) {
            if (dialogScope.showOnlyMineValue === true) {
              return value.user_id === $rootScope.appConfig.user.id;
            }

            return true;
          };

          dialogScope.addTemplate = function () {
            var dialogScope2 = $scope.$new(true);

            dialogScope2.item = {};

            ngDialog.openConfirm({
              template: 'app/views/dialogs/item-project-indicator-template.html',
              className: 'ngdialog-theme-default',
              scope: dialogScope2
            }).then(function () {
              dialogScope.loading = true;

              $api.add({
                model: 'project_indicator_template',
                data: dialogScope2.item
              }).then(function (response) {
                $api.getOne({
                  model: 'project_indicator_template',
                  data: {
                  },
                  id: response.data.id
                }).then(function (response2) {
                  dialogScope.allData.unshift(response2.data);
                  dialogScope.data.unshift(response2.data);
                  dialogScope.loading = false;
                }, function () {
                  dialogScope.loading = false;
                });
              }, function () {
                dialogScope.loading = false;
              });
            });
          };

          dialogScope.reorder = function () {
            try {
              dialogScope.$applyAsync(function () {
                var reverse = false;

                if (!dialogScope.sort) {
                  dialogScope.sort = 'asc';
                } else if (dialogScope.sort === 'asc') {
                  reverse = true;
                  dialogScope.sort = 'desc';
                } else if (dialogScope.sort === 'desc') {
                  dialogScope.sort = 'asc';
                }

                dialogScope.data.sort(function (a, b) {
                  return a.name.localeCompare(b.name);
                });

                if (reverse) {
                  dialogScope.data.reverse();
                }
              });
            } catch (error) {
              Raven.captureException(error);
            }
          };

          getIndicatorTemplates().then(function (response) {
            dialogScope.$applyAsync(function () {
              dialogScope.allData = response.data;
              dialogScope.data = response.data;
              dialogScope.loading = false;
            });
          });

          ngDialog.openConfirm({
            template: 'app/views/dialogs/project-indicator-templates.html',
            className: 'ngdialog-theme-default ngdialog-wide',
            scope: dialogScope
          }).then(function () {
            dialogScope.$applyAsync(function () {
              var newIndex = index;

              dialogScope.data.forEach(function (indicatorTemplate) {
                if (indicatorTemplate.selected) {
                  addProjectItem(item, 'project_indicators', {
                    name: indicatorTemplate.name,
                    row_id: newIndex
                  }, newIndex);

                  newIndex = (newIndex + 1);
                }
              });
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var removeItem = function (stack, index) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.message = 'Do you really want to delete?';

          ngDialog.openConfirm({
            template: 'app/views/dialogs/confirm.html',
            scope: dialogScope
          }).then(function () {
            dialogScope.$applyAsync(function () {
              var item = stack[index];

              if (item.id) {
                item.deleted_at = moment();
              } else {
                stack.splice(index, 1);
              }
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var toggleActItem = function (actItemsStack, actStackItem) {
        try {
          $scope.$applyAsync(function () {
            var index = null;

            for (var i = 0; i < actItemsStack.length; i++) {
              if (actStackItem.id) {
                if (actItemsStack[i].id === actStackItem.id) {
                  index = i;
                  break;
                }
              } else if (actItemsStack[i].name === actStackItem.name) {
                index = i;
                break;
              }
            }

            if (index !== null) {
              actItemsStack.splice(index, 1);
            } else {
              actItemsStack.push(actStackItem);
            }
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var toggleActItems = function (projectPartAct, itemType, items) {
        try {
          $scope.$applyAsync(function () {
            if (projectPartAct[itemType].length === items.length) {
              projectPartAct[itemType] = [];
            } else {
              projectPartAct[itemType] = angular.copy(items);
            }
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var getActItemStatus = function (actItemsStack, actStackItem) {
        try {
          var foundItems = actItemsStack.filter(function (actItemsStackItem) {
            if (actStackItem.id) {
              if (actItemsStackItem.id === actStackItem.id) {
                return true;
              }
            } else if (actItemsStackItem.name === actStackItem.name) {
              return true;
            }

            return false;
          });

          var foundItemsQuantity = foundItems.length;

          return Boolean(foundItemsQuantity);
        } catch (error) {
          Raven.captureException(error);
        }

        return false;
      };

      var importRemarks = function (act, file) {
        file.text().then(function (content) {
          try {
            var data = JSON.parse(content);

            data.forEach(function (item) {
              addRemark(act, item.name);
            });
          } catch (error) {
            Raven.captureException(error);
          }
        });
      }

      var sortableOptionsIndicators = {
        stop: function (e, ui) {
          try {
            for (var index in ui.item.sortable.sourceModel) {
              if (index) {
                ui.item.sortable.sourceModel[index].row_id = parseInt(index, 10);
              }
            }

            vm.indicatorsChanged = true;
          } catch (error) {
            Raven.captureException(error);
          }
        },
        handle: '.fa-reorder',
        uiOrderBy: 'row_id',
        axis: 'y'
      };

      var getIndicatorsBlockSize = function (item, index) {
        var currentIndicator = item.project.project_indicators[index];

        if (index > 0) {
          var prevIndicator = item.project.project_indicators[index - 1];

          if (currentIndicator.reference_project_part_id === prevIndicator.reference_project_part_id) {
            return 0;
          }
        }

        var blockSize = 0;

        for (var i = index; i < item.project.project_indicators.length; i++) {
          var nextIndicator = item.project.project_indicators[i];

          if (currentIndicator.reference_project_part_id !== nextIndicator.reference_project_part_id) {
            break;
          }

          blockSize++;
        }

        return blockSize;
      };

      var moveIndicatorsBlockUp = function (item, index) {
        $scope.$applyAsync(function () {
          var currentIndicator = item.project.project_indicators[index];
          var blockSize = 0;
          var moveBlockSize = 0;

          for (var i = index; i < item.project.project_indicators.length; i++) {
            var nextIndicator = item.project.project_indicators[i];

            if (currentIndicator.reference_project_part_id !== nextIndicator.reference_project_part_id) {
              break;
            }

            blockSize++;
          }

          var prevIndicator = item.project.project_indicators[index - 1];

          for (var m = index - 1; m >= 0; m--) {
            var moveIndicator = item.project.project_indicators[m];

            if (prevIndicator.reference_project_part_id !== moveIndicator.reference_project_part_id) {
              break;
            }

            moveBlockSize++;
          }

          for (var n = 0; n < blockSize; n++) {
            array_move(item.project.project_indicators, (n + index), (n + index - moveBlockSize));
          }
        });
      };

      var moveIndicatorsBlockDown = function (item, index) {
        $scope.$applyAsync(function () {
          var currentIndicator = item.project.project_indicators[index];
          var blockSize = 0;
          var moveBlockSize = 0;

          for (var i = index; i < item.project.project_indicators.length; i++) {
            var nextIndicator = item.project.project_indicators[i];

            if (currentIndicator.reference_project_part_id !== nextIndicator.reference_project_part_id) {
              break;
            }

            blockSize++;
          }

          var nextBlockIndicator = item.project.project_indicators[index + blockSize + 0];

          for (var m = (index + blockSize + 0); m < item.project.project_indicators.length; m++) {
            var moveIndicator = item.project.project_indicators[m];

            if (nextBlockIndicator.reference_project_part_id !== moveIndicator.reference_project_part_id) {
              break;
            }

            moveBlockSize++;
          }

          for (var n = 0; n < moveBlockSize; n++) {
            array_move(item.project.project_indicators, (n + index + blockSize), (n + index));
          }
        });
      };

      var sortableOptionsRemarks = {
        stop: function (e, ui) {
          try {
            for (var index in ui.item.sortable.sourceModel) {
              if (index) {
                ui.item.sortable.sourceModel[index].row_id = parseInt(index, 10);
              }
            }
          } catch (error) {
            Raven.captureException(error);
          }
        },
        handle: '.fa-reorder',
        uiOrderBy: 'row_id',
        axis: 'y'
      };

      vm.tableConfig = {
        model: 'project_part',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: [{
            projector: ['id', 'name']
          }, {
            projector_employee: ['id', 'name', 'email', 'phone']
          }, {
            projector_employee_certificate: ['id', 'uid', 'name', 'issue_date']
          }, {
            user: ['id', 'name']
          }, {
            project_part_type: ['id', 'name']
          },
          'project_part_acts.project_part_act_remarks&project_documents&project_indicators&project_approves',
          'project.project_files&project_documents&project_indicators&project_approves&projector'
          ],
          whereHas: [
            ['project', 'archived', '=', false]
          ]
        },
        filters: filters(),
        helpers: {
          copyProjectAttrs: copyProjectAttrs,
          addAct: addAct,
          addProjectItem: addProjectItem,
          addRemark: addRemark,
          addRemarkFromTemplates: addRemarkFromTemplates,
          addIndicatorFromTemplates: addIndicatorFromTemplates,
          removeItem: removeItem,
          toggleActItem: toggleActItem,
          toggleActItems: toggleActItems,
          getActItemStatus: getActItemStatus,
          sortableOptionsIndicators: sortableOptionsIndicators,
          sortableOptionsRemarks: sortableOptionsRemarks,
          colorCode: $rootScope.helpers.colorCode,
          hasPermissionTo: $rootScope.helpers.hasPermissionTo,
          hasPermissionToAddEdit: $rootScope.helpers.hasPermissionToAddEdit,
          getIndicatorsBlockSize: getIndicatorsBlockSize,
          moveIndicatorsBlockUp: moveIndicatorsBlockUp,
          moveIndicatorsBlockDown: moveIndicatorsBlockDown,
          importRemarks: importRemarks,
          moment: moment
        },
        itemLoader: true,
        variables: {
          userId: $rootScope.appConfig.user.id
        },
        lists: {
          act_types: ['initial', 'final']
        },
        resources: [
          'user',
          'project',
          'projector',
          'projector_employee',
          'project_part_type',
          'project_file',
          'user_certificate',
          'projector_employee_certificate'
        ],
        resourceUpdateConditions: {
          project: {
            selected: function (item) {
              return [item.project_id];
            },
            params: function () {
              return {
                selectOptions: ['id', 'uid', 'name', 'received', 'deadline', 'projector_id'],
                archived: false
              };
            }
          },
          projector_employee: {
            watch: 'projector_id',
            params: function (item) {
              return {
                projector_id: item.projector_id ? item.projector_id : 0
              };
            }
          },
          project_file: {
            params: function (item) {
              return {
                project_id: item.project_id ? item.project_id : 0
              };
            }
          },
          user_certificate: {
            watch: 'user_id',
            params: function (item) {
              return {
                selectOptions: ['id', 'uid', 'name', 'issue_date'],
                user_id: item.user_id ? item.user_id : 0
              };
            }
          },
          projector_employee_certificate: {
            watch: 'projector_employee_id',
            params: function (item) {
              return {
                selectOptions: ['id', 'uid', 'name', 'issue_date'],
                projector_employee_id: item.projector_employee_id ? item.projector_employee_id : 0
              };
            }
          }
        },
        fields: [{
          title: 'Type',
          key: 'project_part_type_id',
          order: true
        }, {
          title: 'Deadline',
          key: 'deadline',
          order: true
        }, {
          title: 'Project',
          key: 'project_id',
          order: true
        }, {
          title: 'Responsible user',
          key: 'user_id',
          order: true
        }, {
          title: 'Date',
          key: 'created_at',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-project-part.html',
          superWide: true,
          before: function (item, scope) {
            return new Promise(function (resolve, reject) {
              try {
                if ($stateParams.filters.length !== 0 && $stateParams.filters[0].value.length !== 0) {
                  var projects = scope.resources.project.filter(function (project) {
                    return project.id === $stateParams.filters[0].value[0][2];
                  });

                  if (projects.length === 1) {
                    var project = projects[0];

                    item.project_id = project.id;
                    item.received = project.received;
                    item.deadline = project.deadline;
                    item.projector_id = project.projector_id;
                  }
                }

                resolve();
              } catch (error) {
                Raven.captureException(error);

                reject(error);
              }
            });
          },
          beforeSubmit: prepareData
        },
        edit: {
          template: 'app/views/dialogs/item-project-part.html',
          superWide: true,
          except: [
            'project',
            'projector',
            'projector_employee',
            'projector_employee_certificate',
            'user',
            'project_part_type'
          ],
          before: getDocumentsAndIndicators,
          beforeSubmit: prepareData
        },
        delete: {},
        linkButtons: [{
          title: 'Project',
          icon: 'icon-folder-alt',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('project menu') && $rootScope.helpers.hasPermissionTo('project view'),
          action: function (item) {
            try {
              $state.go('app.page-projects', {
                filters: [{
                  name: $translate.instant('Project part') + ': ' + item.project_part_type.name + (item.project_part_type_name_suffix ? '. ' + item.project_part_type_name_suffix : ''),
                  attr: 'whereHas',
                  value: [
                    ['project_parts', 'id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }, {
          title: 'Projector employee',
          icon: 'icon-user',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('projector_employee menu'),
          action: function (item) {
            try {
              $state.go('app.page-projector-employees', {
                filters: [{
                  name: $translate.instant('Project') + ': ' + item.project.uid + ' - ' + item.project.name + ', ' + $translate.instant('Project part') + ': ' + item.project_part_type.name + (item.project_part_type_name_suffix ? '. ' + item.project_part_type_name_suffix : ''),
                  attr: 'where',
                  value: [
                    ['id', '=', item.projector_employee_id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
